module.exports = __webpack_public_path__ + "files/6507738ad6facc884a7954a75942ee28.png";